///Display Variant E

<template>
	<div class="feature-container">
		<div class="landing-red light-text feature-headline">
			{{feature.headline}}
		</div>	
		<div class="feature-desc-short content-subtext light-text">
				{{feature.descShort}}
		</div>
		
		<span class="images-grid">
			<div v-if="feature.imageDisplay == undefined || feature.imageDisplay == 'firstImage'" class="images-container">
				<div class="image-wrapper">
					<img :src="baseUrl + feature.images[0].url" class="feature-image">
				</div>
			</div> 
			
			<div v-if="feature.imageDispaly =='stackFromBottom'" class="images-container">
				<div class="image-wrapper stacking-wrapper" v-for="img in feature.images" :key="img.id" >
					<img :src="baseUrl + img.url" :style="{zIndex: compIndexTopFirst(img.id)}" style="height: auto;" class="feature-image">
				</div>
			</div> 

			<div v-if="feature.imageDisplay == 'stackFromBottom'" class="images-container">
				<div class="image-wrapper stacking-wrapper" v-for="img in feature.images" :key="img.id" >
					<img :src="baseUrl + img.url" class="feature-image" :style="{zIndex: compIndexBottomFirst(img.id)}">
				</div>
			</div>
			
			<div class="feature-desc-long content-description light-text">
				{{feature.descLong}}
			</div>
		</span>

	</div>
</template>

<script>
		export default {
			Name: 'FeatureVariantFive',
			
			props: {
				feature: {type:Object},
				baseUrl: String,
			},

			methods: {
				compIndexTopFirst(key) {
					return 1000 - this.feature.images.findIndex(img => img.id == key);
				},
				
				compIndexBottomFirst(key) {
					return 1000 + this.feature.images.findIndex(img => img.id == key);
				},
				
				
			}
		}
</script>

<style scoped>
	.feature-container {
		align-items: center;
		display: grid;
	}

	.images-grid {
		display: grid;
		grid-template-columns: 3fr 2fr;
		margin: auto;
	}

	.feature-desc-long {
		display: grid;
		align-self: end;
		text-align: left;
		margin-right: 2em;
	}
	
	.feature-desc-short {
		margin-bottom: 0;
	}

	.images-container {
		align-self: left;
		margin-top: 0;
		margin-bottom: 0;
	}



</style>